import React from 'react';
import { useHistory } from 'react-router-dom';

import { adminApi } from './adminApi';
import { DataTable, EmptyState, PageHeader, SearchInput } from './kit';
import useListState from './useListState';
import { formatDocument, useSlashToSearch } from './ui';

const COLUMNS = [
  { key: 'name', label: 'Oficina', render: (c) => <strong className='ax-strong'>{c.tradingName || c.name}</strong> },
  { key: 'cnpj', label: 'CNPJ', width: '190px', render: (c) => formatDocument(c.cpfCnpj) },
  { key: 'city', label: 'Cidade', width: '200px', render: (c) => [c.city, c.state].filter(Boolean).join(' / ') || '—' },
  {
    key: 'origin',
    label: 'Origem',
    width: '170px',
    align: 'right',
    render: (c) => (
      <>
        {!c.isActive && <span className='ax-badge'>Inativa</span>}
        <span className='ax-muted'>{c.origin}</span>
      </>
    ),
  },
];

async function load({ q }) {
  const { results, osDigitalUnavailable } = await adminApi.searchCompanies(q);
  return { results, total: results.length, note: osDigitalUnavailable ? 'O OS Digital não respondeu: a lista mostra só as oficinas do Sobre Rodas.' : null };
}

// Oficinas: busca por nome ou CNPJ no Sobre Rodas e no OS Digital.
export default function CompaniesPage() {
  const history = useHistory();
  useSlashToSearch('ax-companies-search');
  const list = useListState({ load, enabled: ({ q }) => q.length >= 3 });
  const { state, q } = list;

  return (
    <div className='ax-page'>
      <PageHeader title='Oficinas' meta={q && state.status === 'done' ? `${state.results.length} ${state.results.length === 1 ? 'resultado' : 'resultados'}` : null} />

      <div className='ax-toolbar'>
        <SearchInput id='ax-companies-search' value={list.input} onChange={list.setInput} placeholder='Buscar por nome da oficina ou CNPJ' busy={state.status === 'loading'} />
      </div>

      {state.error && <p className='ax-alert' role='alert'>{state.error}</p>}
      {state.note && <p className='ax-alert is-warn'>{state.note}</p>}

      {!q && <EmptyState title='Busque uma oficina' text='Digite ao menos 3 letras do nome ou o CNPJ. A busca roda no Sobre Rodas e no OS Digital.' />}

      {q && (
        <DataTable
          columns={COLUMNS}
          rows={state.results}
          rowKey={(c) => `${c.sourceId}-${c.cpfCnpj}`}
          onRowClick={(c) => history.push(`/admin/companies/${String(c.cpfCnpj || '').replace(/\D/g, '')}`)}
          loading={state.status === 'loading'}
          empty={state.status === 'done' ? (
            <EmptyState
              title={`Nenhuma oficina encontrada para “${q}”`}
              action={<button type='button' className='ax-btn' onClick={() => { list.setInput(''); list.update({ q: '' }); }}>Limpar busca</button>}
            />
          ) : null}
        />
      )}
    </div>
  );
}
